import firebase from "firebase";

// See firebase setup in above google firebase documentation url
export const config = {
  apiKey: "AIzaSyAIz6S5AehqnVYQHjvplSTOCLXu3kwnpDc",
  authDomain: "fire-jitsu-chat.firebaseapp.com",
  databaseURL: "https://fire-jitsu-chat.firebaseio.com",
  projectId: "fire-jitsu-chat",
  storageBucket: "fire-jitsu-chat.appspot.com",
  messagingSenderId: "325899797261"
};

firebase.initializeApp(config);
const firestore = firebase.firestore();
const settings = {
  timestampsInSnapshots: true
};
firestore.settings(settings);
export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js